import request from '@/utils/request'


// 查询商品足迹分页
export function pageGoodsBrowse(query) {
  return request({
    url: '/biz/admin/goods/goods/browse/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
